<template>
  <div class="main pages-videos-details">
    <div class="title-bar d-none d-lg-block">
      <a
        v-if="video.enable_sharing"
        class="btn btn-primary float-right"
        href="#"
        @click.prevent="share()"
        >Share This Video</a
      >
      <h1 class="mb-0">{{ video.title }}</h1>
      <a class="btn-back text-primary" :href="route('videos.index')">
        <span class="icon icon-arrow-left"></span>
        <span class="text">Back to List</span>
      </a>
    </div>
    <div class="row no-gutters p-lg-4">
      <div class="col-12">
        <transition name="fade">
          <Alert v-if="hasAlert" :alert="alert" />
        </transition>
      </div>
      <div class="video-content col-12 col-lg-6 col-xl-5 mb-lg-3">
        <div class="video-player bg-white">
          <iframe
            :src="video.video_url"
            frameborder="no"
            allowfullscreen
            webkitallowfullscreen
            mozallowfullscreen
          ></iframe>
        </div>
        <div class="video-details bg-white p-3 pb-5">
          <h1 class="mb-0 d-lg-none">{{ video.title }}</h1>
          <div class="video-meta">
            <div class="text-uppercase">
              <span class="text-uppercase font-weight-bold text-primary"
                >Topic:</span
              >
              <span class="ml-2">{{ video.topic || "N/A" }}</span>
            </div>
            <div class="text-uppercase">
              <span class="text-uppercase font-weight-bold text-primary"
                >Length:</span
              >
              <span class="ml-2">{{ video.length }}</span>
            </div>
          </div>
          <div
            v-if="video.description"
            v-html="video.description"
            class="video-description"
          ></div>
          <div v-if="video.downloads.length > 0" class="video-downloads">
            <h4 class="text-uppercase">Downloads</h4>
            <a
              v-for="(download, i) in video.downloads"
              :key="i"
              :href="download.asset.url"
              target="_blank"
              class="download pill"
            >
              <span class="text">{{ download.asset.name }}</span>
              <icon icon="download" class="icon" />
            </a>
          </div>
          <div class="pt-3">&nbsp;</div>
          <div
            v-if="video.enable_sharing"
            class="video-sharing text-center pt-4"
          >
            <a class="btn btn-primary" href="#" @click.prevent="share()"
              >Share This Video</a
            >
          </div>
        </div>
      </div>
      <div class="col-12 px-3 pt-4 col-lg-6 pt-lg-0 col-xl-7">
        <div
          v-if="video.suggested_videos.length > 0"
          class="suggested-videos row no-gutters"
        >
          <h2 class="mb-4 text-center w-100">Suggested Videos</h2>
          <div
            v-for="(item, i) in video.suggested_videos"
            :key="i"
            class="col-12 col-md-6 pb-3 px-md-2"
          >
            <VideoCard :video="item" orientation="landscape" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoCard from "./partials/ListCard";
import ShareModal from "./partials/ShareVideo";
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  components: { VideoCard, ShareModal },
  props: {
    video: { type: Object, required: true },
  },
  methods: {
    share() {
      this.$modal(ShareModal)
        .then((email) => {
          this.axios
            .post(this.route("videos.share", { video: this.video.id }), {
              email: email,
            })
            .then(() => {
              this.showAlert(
                "success",
                `This video has been shared with: ${email}`,
                true
              );
            });
        })
        .catch(() => {});
    },
  },
};
</script>
